export default __webpack_public_path__ + "static/media/pointblankshot.98f43222.png";